var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-steps',{attrs:{"active":_vm.active,"finish-status":"success","align-center":""}},[_c('el-step',{attrs:{"title":"Paso 1","description":"Evaluación de nivel"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"Paso 2","description":"Formulario de reserva"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }